import React from 'react';
import './order-detail-order-only.css';

interface OrderActionsMenuProps {
  readonly open: boolean;
  readonly onToggle: () => void;
  readonly onReset: () => void;
  readonly resetting?: boolean;
  readonly canRelease?: boolean;
  readonly releasing?: boolean;
  readonly onRelease?: () => void;
  /** Order detail passes this only for admins. Bundle work leaves it unset. */
  readonly onSplitShipment?: () => void;
  /** Order detail passes this only when Print and scan order label is on. */
  readonly onReprintOrderLabel?: () => void;
  readonly reprintingOrderLabel?: boolean;
  /** Post-submit nav only. */
  readonly showSubmittedActions?: boolean;
  readonly onRetakePackingImage?: () => void;
  readonly onRetakeBoxDimImage?: () => void;
  /** Defaults to Order. Bundle work passes Bundle. */
  readonly actionName?: string;
  readonly onChangeBaseline?: () => void;
  /** Admin/dev only; callers pass it only for those roles. */
  readonly onMarkScanned?: () => void;
}

function OrderActionsMenu({
  open,
  onToggle,
  onReset,
  resetting = false,
  canRelease = false,
  releasing = false,
  onRelease,
  onSplitShipment,
  onReprintOrderLabel,
  reprintingOrderLabel = false,
  showSubmittedActions = false,
  onRetakePackingImage,
  onRetakeBoxDimImage,
  actionName = 'Order',
  onChangeBaseline,
  onMarkScanned,
}: OrderActionsMenuProps): React.ReactElement {
  return (
    <div className="scanner-action-menu">
      <button
        type="button"
        className="scanner-control-btn scanner-action-btn"
        onClick={onToggle}
        aria-expanded={open}
        aria-haspopup="menu"
        aria-label={`${actionName} Actions`}
      >
        <span className="scanner-action-btn-label">
          <span>{actionName}</span>
          <span>Actions</span>
        </span>
      </button>
      {open ? (
        <div className="scanner-action-menu-panel" role="menu">
          {onSplitShipment ? (
            <button
              type="button"
              role="menuitem"
              className="scanner-action-menu-item"
              onClick={onSplitShipment}
            >
              Split Shipments
            </button>
          ) : null}
          {onReprintOrderLabel ? (
            <button
              type="button"
              role="menuitem"
              className="scanner-action-menu-item"
              disabled={reprintingOrderLabel}
              onClick={onReprintOrderLabel}
            >
              {reprintingOrderLabel ? 'Printing…' : 'Reprint order label'}
            </button>
          ) : null}
          {showSubmittedActions && onRetakePackingImage ? (
            <button
              type="button"
              role="menuitem"
              className="scanner-action-menu-item"
              onClick={onRetakePackingImage}
            >
              Retake Packing Image
            </button>
          ) : null}
          {showSubmittedActions && onRetakeBoxDimImage ? (
            <button
              type="button"
              role="menuitem"
              className="scanner-action-menu-item"
              onClick={onRetakeBoxDimImage}
            >
              Retake Box Dim Image
            </button>
          ) : null}
          {canRelease && onRelease ? (
            <button
              type="button"
              role="menuitem"
              className="scanner-action-menu-item scanner-action-menu-item-release"
              disabled={releasing}
              onClick={onRelease}
            >
              Release Order
            </button>
          ) : null}
          {onChangeBaseline ? (
            <button
              type="button"
              role="menuitem"
              className="scanner-action-menu-item"
              onClick={onChangeBaseline}
            >
              Change Baseline
            </button>
          ) : null}
          {onMarkScanned ? (
            <button
              type="button"
              role="menuitem"
              className="scanner-action-menu-item"
              onClick={onMarkScanned}
            >
              Mark Scanned (ADMIN)
            </button>
          ) : null}
          <button
            type="button"
            role="menuitem"
            className="scanner-action-menu-item"
            disabled={resetting}
            onClick={onReset}
          >
            {resetting ? 'Resetting…' : 'Reset Order'}
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default OrderActionsMenu;
